module.exports = __webpack_public_path__ + "img/freeNode.9732dc59.svg";